<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Edit Application Scripts</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  
  <div class="modal-body">
    <p style="line-break: anywhere;">For editing or updating applications {{data.fileType.toLowerCase().split(" ")[0]}} scripts, <strong>login to host server</strong> and navigate to the path mentioned below.</p>
    <p style="line-break: anywhere;">Path : <span class="synchpc-primary">{{webRootPath}}</span></p>
  </div>

  <div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
		<button type="button" class="btn btn-primary" (click)="onSubmit()">
			Copy Path & Close
		</button>
	</div>
</div> 